<template>
  <div class="object-deal">
    <div class="od_wrap">
      <img :src="`/static/grx/icons/objects/${dataSource.Transient.Object.Type}.svg`"
        class="od_icon">

      <h2 class="od_title">
        <router-link :to="`/object/${this.dataSource.ObjectId}`">
          {{ dataSource.Transient.Object.Title }}
        </router-link>
      </h2>

      <div class="od_info">
        <div class="od_info-el" v-if="dealsMode === 'foreignObjects'">
          Инициатор сделки:
          <router-link :to="`/user/${this.dataSource.UserId}/profile/view`">
            {{ dealInitiator }}
          </router-link>
        </div>
        <div class="od_info-el od-license">
          {{ dealLicense }}
        </div>
        <div class="od_info-el od_created-time">
          Дата сделки: {{ dealTime }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  props: {
    dataSource: null,
    dealsMode: '',
  },

  computed: {

    dealTime() {
      let time = '';
      if (this.dataSource && this.dataSource.Timestamp) {
        const d = new Date(this.dataSource.Timestamp * 1000);
        const year = d.getFullYear();

        let month = d.getMonth() + 1;
        if (month < 10) month = `0${month}`;

        let date = d.getDate();
        if (date < 10) date = `0${date}`;

        let hours = d.getHours();
        if (hours < 10) hours = `0${hours}`;

        let minutes = d.getMinutes();
        if (minutes < 10) minutes = `0${minutes}`;

        time = `${date}.${month}.${year} ${hours}:${minutes}`;
      }
      return time;
    },

    dealLicense() {
      if (this.dataSource && this.dataSource.Transient.Contract) {
        return this.dataSource.Transient.Contract.Title;
      }
      return '';
    },

    dealInitiator() {
      if (this.dataSource.Transient.User && this.dealsMode === 'foreignObjects') {
        return `${this.dataSource.Transient.User.Surname} ${this.dataSource.Transient.User.Name} ${this.dataSource.Transient.User.Patronymic}`;
      }
      return '';
    },

  },

};
</script>

<style lang="scss">
@import "../styles/common/main";

.object-deal {
  -webkit-box-shadow: 0 1px 12px rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.15);
  margin: 20px 0;
  padding: 30px 30px 25px;
  border-radius: 10px;
  min-height: 55px;
  position: relative;
  overflow: hidden;
  .od_wrap {
    position: relative;
    padding-left: 70px;
    padding-right: 220px;
    .od_info {
      .od_info-el {
        font-size: 15px;
        display: block;
        margin-right: 20px;
        max-width: 800px;
        color: #aaa;
      }
      .od_type {
        cursor: help;
      }
    }
    .od_icon {
      position: absolute;
      left: -2px;
      top: 0;
      width: auto;
      height: 50px;
    }
    .od_title {
      cursor: pointer;
      font-size: 18px;
      line-height: 20px;
      margin: 0 0 10px;
      padding: 0;
      font-weight: normal;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ObjectDeal.vue